<template>
  <div class="partnerFormContainer">
    <v-card class="signupFormCard">
      <v-card-title class="formTitle justify-start pa-1">
        Sign Up & Join Now</v-card-title
      >
      <div class="formContent">
        <v-form ref="signUpRef">
          <v-text-field
            label="Name*"
            outlined
            dense
            :rules="firstNameRules"
            v-model="signUpInput.firstName"
            class="formField"
          ></v-text-field>
          <v-text-field
            label="Email*"
            outlined
            dense
            :rules="emailRules"
            v-model="signUpInput.emailId"
            class="formField"
          ></v-text-field>
          <v-text-field
            label="Mobile*"
            outlined
            dense
            :rules="mobileRules"
            v-model="signUpInput.mobile"
            class="formField"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="Select State"
            :rules="stateRequired"
            :items="state"
            v-model="signUpInput.state"
            class="formField"
          ></v-select>
          <v-select
            dense
            outlined
            label="Select Age Range"
            :rules="agrRangeRequired"
            item-text="name"
            item-value="id"
            return-object
            :items="getAgeRange"
            v-model="signUpInput.ageRange"
            class="formField"
          ></v-select>
          <v-text-field
            label="Password"
            type="password"
            outlined
            dense
            :rules="passwordRules"
            v-model="signUpInput.password"
            class="formField"
          ></v-text-field>
          <v-text-field
            label="Confirm Password"
            type="password"
            outlined
            dense
            :rules="confirmPasswordRules"
            v-model="confirmPassword"
            class="formField"
          ></v-text-field>

          <div class="check-box-container">
            <div>
              <v-checkbox color="primary" v-model="checked" />
              <p class="help-text-terms">
                I have read and agree to the
                <span class="term-link" @click="closeModel(true)">
                  Terms & Conditions
                </span>
              </p>
            </div>
          </div>
        </v-form>
        <button
          type="button"
          class="btn btn-secondary calculator-btn signupButton"
          @click="onSignUp"
          :disabled="!checked"
        >
          Become a FREED Partner
          <!-- <div class="icon-container">
            <img
              src="@/assets/images/paper-plane-blue.svg"
              class="img-fluid w-100e"
              alt="..."
            />
          </div> -->
        </button>
        <div class="formFooter">
          Already Registered?
          <div class="term-link" @click="goToLogin">Login</div>
        </div>
      </div>
    </v-card>
    <TermsAndCondition :open="open" @close="closeModel" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import store, * as Store from '@/../src-gen/store';
import * as Data from '@/../src-gen/data';
import * as Action from '@/../src-gen/action';
import Snackbar from 'node-snackbar';
import TermsAndCondition from './termsAndConditions.vue';

@Component({
  components: {
    TermsAndCondition,
  },
})
export default class SignupForm extends Vue {
  open = false;
  @Prop({ default: 0 })
  carousel: any;
  ageRangeList: any = Data.Partner.AGE_RANGE.list();
  checked: boolean = false;
  confirmPassword: string = '';
  state: string[] = [];
  content = [
    { subTitle: 'Make Money Helping People' },
    { subTitle: 'Work Part-Time Earn Full-Time' },
    { subTitle: 'Transparent Weekly Payout' },
  ];
  signUpInput: Data.Partner.SignUpInput = new Data.Partner.SignUpInput();
  emailRules = [
    (v: any) => !!v.trim() || 'Email is required',
    (v: any) => v.indexOf(' ') === -1 || 'Provide a valid Email',
    (v: any) => /.+@.+\..+/.test(v) || 'Provide a valid Email',
  ];
  // stateRequired = [(v: any) => !!v.trim() || 'State is required'];
  stateRequired = [(v: any) => (v && !!v.trim()) || 'State is required'];

  agrRangeRequired = [(v: any) => !!v || 'Age range is required'];
  firstNameRules = [(v: any) => !!v.trim() || 'Name is required'];
  mobileRules = [
    (v: any) => !!v || 'Mobile Number is required',
    (v: any) => {
      const value = v?.replace(' ', '');
      return (!!value && value.length === 10) || 'Please Enter valid  Number';
    },
  ];
  passwordRules = [(v: any) => !!v || !!v.trim() || 'Password  is required'];
  confirmPasswordRules = [
    (v: any) => !!v || !!v.trim() || 'Confirm Password  is required',
    (v: any) =>
      v === this.signUpInput.password || "Confirm Password  doesn't match",
  ];
  goToLogin() {
    this.$router.push({ name: 'Login.Login' });
  }
  closeModel(model: boolean = false) {
    this.open = model;
  }
  get getAgeRange() {
    return this.ageRangeList.sort((a: any, b: any) => {
      const c = '';
      const [first] = a.name.includes('+')
        ? a.name.split('+')
        : a.name.split('-');
      const [second] = b.name.includes('+')
        ? b.name.split('+')
        : b.name.split('-');

      return first - second;
    });
  }
  mounted() {
    this.getStateList();
  }
  getStateList() {
    Action.Partner.GetStateList.execute((output) => {
      this.state = output.stateNameList;
    });
  }

  onSignUp() {
    const valid = (this.$refs.signUpRef as any).validate();
    if (valid && this.checked) {
      const [firstName = '', lastName = ''] =
        this.signUpInput.firstName.split(' ');
      this.signUpInput.firstName = firstName;
      this.signUpInput.lastName = lastName;
      Action.Partner.SignUp.execute(this.signUpInput, (output) => {
        Snackbar.show({
          text: 'Register Successful! Please Log In',
          pos: 'bottom-center',
        });
        this.$router.push({ name: 'Login.Login' });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.partnerFormContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%;
  max-width: 500px;
  background-color: transparent;
  margin-top: 60px;
  margin-bottom: 60px;
  margin-right: 60px;
  margin-left: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  height: fit-content;
}

.signupFormCard {
  width: 100%;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #02416e !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 780px;
  display: flex;
  flex-direction: column;
}

.formContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.formTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #02416e;
  flex-shrink: 0;
  text-align: left;
}

.formField {
  margin-bottom: 10px;
  flex-shrink: 0;
}

::v-deep .v-input {
  margin-bottom: 0 !important;
}

::v-deep .v-input__control {
  min-height: 36px !important;
}

::v-deep .v-text-field--outlined fieldset {
  border-color: #02416e !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #02416e !important;
}

::v-deep .v-select--outlined fieldset {
  border-color: #02416e !important;
}

::v-deep .v-select--outlined.v-input--is-focused fieldset {
  border-color: #02416e !important;
}

::v-deep .v-text-field--outlined .v-input__slot input::placeholder,
::v-deep .v-text-field--outlined .v-input__slot textarea::placeholder {
  color: #02416e !important;
  opacity: 0.7;
}

::v-deep .v-text-field--outlined label,
::v-deep .v-select--outlined label {
  color: #02416e !important;
}

.check-box-container {
  margin: 4px 0;
  flex-shrink: 0;
  > div {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
  }
  p {
    margin: 0;
    margin-left: 8px;
    font-size: 13px;
    line-height: 1.5;
    padding-top: 2px;
  }
}

::v-deep .check-box-container .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

::v-deep .check-box-container .v-input--selection-controls__input {
  margin-right: 0;
}

::v-deep .check-box-container .v-input__control {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 0;
}

::v-deep .check-box-container .v-input__slot {
  margin-bottom: 0;
  align-items: flex-start;
  padding-top: 0;
}

::v-deep .check-box-container .v-input--selection-controls .v-input__slot {
  align-items: flex-start;
}

.help-text-terms {
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 14px;
  color: #02416e;
}

.signupButton {
  width: 100%;
  margin-top: 12px;
  padding: 12px;
  background-color: #f36f21 !important;
  border-color: #f36f21 !important;
  color: white;
  font-weight: bold;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.formFooter {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  font-size: 14px;
  flex-shrink: 0;
  color: #02416e;
}

.term-link {
  color: #f36f21;
  cursor: pointer;
  font-weight: bold;
}

@media screen and (max-width: 960px) {
  .partnerFormContainer {
    position: relative;
    max-width: 100%;
    margin: 0;
    padding: 20px;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    width: 100%;
  }

  .signupFormCard {
    padding: 20px;
    max-height: none;
    display: block;
    width: 100%;
    margin: 0 auto;
  }
  
  .formContent {
    display: block;
    width: 100%;
  }

  .formTitle {
    font-size: 24px;
    text-align: left;
    padding-left: 0;
  }

  .help-text-terms {
    font-size: 13px;
    display: inline;
    word-wrap: break-word;
  }

  .check-box-container {
    > div {
      flex-wrap: wrap;
    }
    p {
      margin-left: 8px;
      flex: 1;
      min-width: 0;
      word-wrap: break-word;
    }
  }

  .term-link {
    display: inline;
    word-break: break-word;
  }

  .formField {
    margin-bottom: 12px;
  }

  .signupButton {
    width: 100%;
    margin-top: 16px;
  }

  .formFooter {
    margin-top: 16px;
  }
}
</style>
